export const calculateStatistics = ({
    transactions,
    selectedScrip,
    selectedPartner,
    holdings
}) => {

    const partnerId = selectedPartner?.id || "all";

    // 🔥 FILTER TRANSACTIONS CORRECTLY
    const relevantTransactions = transactions.filter(t =>
        (selectedScrip === "all" || t.scrip === selectedScrip) &&
        (partnerId === "all" || t.partnerId === partnerId)
    );

    const scripMap = {};
    let totalCommission = 0;

    relevantTransactions.forEach((tx) => {
        const shareAmount = Number(tx.quantity) * Number(tx.rate);

        const commission =
            tx.transactionType === "BUY"
                ? Number(tx.amount) - shareAmount
                : shareAmount - Number(tx.amount);

        totalCommission += commission;

        if (!scripMap[tx.scrip]) {
            scripMap[tx.scrip] = {
                buyQty: 0,
                sellQty: 0,
                buyAmount: 0,
                sellAmount: 0
            };
        }

        if (tx.transactionType === "BUY") {
            scripMap[tx.scrip].buyQty += Number(tx.quantity);
            scripMap[tx.scrip].buyAmount += Number(tx.amount);
        } else {
            scripMap[tx.scrip].sellQty += Number(tx.quantity);
            scripMap[tx.scrip].sellAmount += Number(tx.amount);
        }
    });

    let totalBillAmount = 0;
    let totalReceivableAmount = 0;

    Object.keys(scripMap).forEach((scrip) => {
        const stock = scripMap[scrip];

        // ✅ Skip if still holding
        if (holdings[scrip]) return;

        // ✅ Only fully closed positions
        if (stock.buyQty === stock.sellQty) {
            totalBillAmount += stock.buyAmount;
            totalReceivableAmount += stock.sellAmount;
        }
    });

    const grossNetProfitLoss = totalReceivableAmount - totalBillAmount;

    const totalCapitalGain =
        grossNetProfitLoss > 0 ? grossNetProfitLoss * 0.075 : 0;

    const netProfitLoss = grossNetProfitLoss - totalCapitalGain;

    return {
        totalTransactions: relevantTransactions.length,

        uniqueScripsCount: [
            ...new Set(relevantTransactions.map(t => t.scrip))
        ].length,

        totalScripQuantity: relevantTransactions.reduce(
            (sum, t) => sum + Number(t.quantity),
            0
        ),

        totalBillAmount: totalBillAmount.toFixed(2),
        totalReceivableAmount: totalReceivableAmount.toFixed(2),
        totalCommission: totalCommission.toFixed(2),
        grossNetProfitLoss: grossNetProfitLoss.toFixed(2),
        totalCapitalGain: totalCapitalGain.toFixed(2),
        netProfitLoss: netProfitLoss.toFixed(2)
    };
};